/** 展示用原价，与现有定价页口径一致；不参与支付金额计算。 */
export function getSubscriptionOriginalPrice(slug: string, price: number, currency: string): number | null {
  if (currency !== 'USD' || !Number.isFinite(price) || price <= 0) return null;
  const cents = Math.round(price * 100);
  const originalCents = slug === 'basic' ? 1599
    : slug === 'pro' ? cents + 1500
      : slug === 'ultimate' ? cents + 2000 : null;
  return originalCents !== null && originalCents > cents ? originalCents / 100 : null;
}

export function getSubscriptionDiscountPercent(slug: string, price: number, currency: string): number | null {
  const original = getSubscriptionOriginalPrice(slug, price, currency);
  if (original === null) return null;
  const originalCents = Math.round(original * 100);
  const percent = Math.floor((originalCents - Math.round(price * 100)) * 100 / originalCents);
  return percent > 0 ? percent : null;
}

interface DiscountPlan {
  slug: string;
  price_monthly: number;
  price_options?: { price_monthly: number; is_purchasable?: boolean }[];
}

export function getMaximumSubscriptionDiscount(plans: DiscountPlan[], currency: string): number | null {
  let maximum = 0;
  for (const plan of plans) {
    const prices = plan.price_options?.length
      ? plan.price_options.filter(option => option.is_purchasable !== false).map(option => option.price_monthly)
      : [plan.price_monthly];
    for (const price of prices) {
      maximum = Math.max(maximum, getSubscriptionDiscountPercent(plan.slug, price, currency) ?? 0);
    }
  }
  return maximum > 0 ? maximum : null;
}
